import {EventEmitter, Injectable} from "@angular/core";

@Injectable()
export class StatusPanelService {
    /**
     * Event emitted if any status panel has saved
     */
    statusSaved: EventEmitter<any> = new EventEmitter();
}
